<template>
    <h1
        :class="['SearchHeading', { 'isLoading': loading }]"
        v-skeleton="{
            loading,
            sizes: {
                Small: { width: '100%', height: '2rem' },
                ExtraLarge: { width: '100%', height: '2rem' },
            }
        }"
    >{{ searchStore.pageTitle }}</h1>
</template>


<script setup lang="ts">
import { computed } from 'vue';
import { useSearchStore } from '@app/stores/useSearchStore';
const searchStore = useSearchStore();

const loading = computed(() => searchStore.loading);

</script>

<style scoped lang="scss">
    h1.SearchHeading {
            color: $Grey-900;

            @include TextStyle(HeadingSmall);

            @include Breakpoint(Medium, Large, ExtraLarge) {
                @include TextStyle(HeadingMedium);
            }

            margin: 0.5em 0 !important;
        }
</style>